<itc-auth-container>
  <div content class="mobile-stub__container">
    <div class="mobile-stub__header">
      <itc-themed-image
        lightSrc="assets/icons/kaseya-one/kaseya-one-logo-light.svg"
        darkSrc="assets/icons/kaseya-one/kaseya-one-logo-dark.svg"
        [width]="77"
        [height]="15"
        [alt]="'login.alts.logo' | translate"
      />
      <div class="mobile-stub__header-text">
        {{ 'mobile-stub.header.title' | translate }}
      </div>
    </div>
    <div class="mobile-stub__content">
      <itc-themed-image
        lightSrc="assets/icons/kaseya-365/k365-logo-light.svg"
        darkSrc="assets/icons/kaseya-365/k365-logo-dark.svg"
        [width]="74"
        [height]="56"
        [alt]="'mobile-stub.alts.k365' | translate"
      />
      <div class="mobile-stub__content-title">
        {{ 'mobile-stub.title' | translate }}
      </div>
      <div class="mobile-stub__content-description">
        {{ 'mobile-stub.description' | translate }}
      </div>
      <div class="mobile-stub__content-list">
        <div class="mobile-stub__content-list-title">
          {{ 'mobile-stub.list.title' | translate }}
        </div>
        @for (key of pointKeys; track key) {
          <div class="mobile-stub__content-list-item">
            <i aria-hidden="true" class="mobile-stub__content-list-item-icon fa-regular fa-check"></i>
            <span class="mobile-stub__content-list-item-text">{{ 'mobile-stub.list.' + key | translate }}</span>
          </div>
        }
        <div class="mobile-stub__content-list-item-text">
          {{ 'mobile-stub.list.more' | translate }}
        </div>
      </div>
      @if (isAuthorized) {
        <div class="mobile-stub__button">
          <kds-large-button [buttonText]="'mobile-stub.log-out' | translate" (buttonClick)="logoutFromKaseyaOne()" />
        </div>
      }
    </div>
  </div>
</itc-auth-container>
